import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'Relatório de diárias',
    defaultMessage: 'Relatório de diárias',
  },
  formTitle: {
    id: 'Título',
    defaultMessage: 'Título',
  },
});

export const diariasSchema = (props) => {
  return {
    title: props.intl.formatMessage(messages.title),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['title'],
      },
    ],
    properties: {
      title: {
        title: props.intl.formatMessage(messages.formTitle),
      },
    },
    required: ['title'],
  };
};
